import React from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faExclamationTriangle
} from "@fortawesome/fontawesome-free-solid/";
import axios from "axios";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    // set initial state to loading
    this.state = {
      emailIsValid: true,
    };

    this.validateEmail = this.validateEmail.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateEmail(event) {
    const email = event.target.value;

    // if empty reset to valid
    if (!email) {
      this.setState({emailIsValid: true});
      return;
    }

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({emailIsValid: re.test(String(email).toLowerCase())});
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});

    if (e.target.name === "email") {
      this.validateEmail(e);
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const {emailIsValid} = this.state;
    if (!emailIsValid) {
      this.setState({formInvalid: true});
      return;
    }

    this.setState({formInvalid: false, loading: true});

    const url = "https://oncezone.netlify.com/.netlify/functions/contact";
    
    const {name, email, message} = this.state;

    axios.get(url, {
      params: {
        name,
        email,
        message,
      }
    })
      .then(res => {
        if (res.data.success) {
          this.setState({success: true});
        } else {
          this.setState({success: false, error: true});
        }
      })
      .catch(err => {
        console.error("Error submitting form:", err);
        this.setState({success: false, error: true});
      });
  }

  render() {
    const {success, error, loading, emailIsValid, formInvalid} = this.state;

    if (success) {
      return (
        <div>
          <p className="title is-2 has-text-white">
            Sent your message!
          </p>
          <p className="subtitle is-3 has-text-white">
            We will get back to you soon. :)
          </p>
        </div>
      );
    }

    if (error) {
      return (
        <div>
          <p className="title is-3 has-text-white">
            An error occurred while sending your message :(
          </p>
        </div>
      );
    }

    return (
      <div>
        <h1 className="title is-1 has-text-white">
          Ask Us!
        </h1>
        <p className="has-text-white">
          Any questions about twice or the funbase can be asked here! Read the note below for more information before sending in any inquiries!
        </p>
        <form onSubmit={this.handleSubmit}>
          <div className="field is-horizontal">
            <div className="field-body">
              <div className="field">
                <label className="label has-text-white" htmlFor="form-name">
                  Name
                  <div className="control">
                    <input
                      className="input"
                      name="name"
                      id="form-name"
                      type="text"
                      placeholder="Park Jin-young"
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </label>
              </div>

              <div className="field">
                <label className="label has-text-white" htmlFor="form-email">
                  Email
                  <div className="control has-icons-left has-icons-right">
                    <input
                      className={`input ${!emailIsValid ? "is-danger" : ""}`}
                      id="form-email"
                      name="email"
                      type="email"
                      placeholder="email@example.com"
                      onChange={this.handleChange}
                      required
                    />
                    <span className="icon is-small is-left">
                      <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                    {
                      !emailIsValid ?
                        (
                          <span className="icon is-small is-right">
                            <FontAwesomeIcon icon={faExclamationTriangle} />
                          </span>
                        ) : null
                    }
                  </div>
                  {
                    !emailIsValid ?
                      (
                        <p className="help is-danger">
                          This email is invalid
                        </p>
                      ) : null
                  }
                </label>
              </div>
            </div>
          </div>

          <div className="field">
            <label className="label has-text-white" htmlFor="form-message">
              Message
              <div className="control">
                <textarea
                  className="textarea"
                  id="form-message"
                  name="message"
                  placeholder="Write a message"
                  onChange={this.handleChange}
                  required
                />
              </div>
            </label>
          </div>
          <div className="field">
            <div className="control">
              <button
                type="button"
                className={`button is-link ${loading ? "is-loading" : ""}`}
                onClick={this.handleSubmit}
              >
                Submit
              </button>
              {
                formInvalid ?
                  (
                    <p className="help is-danger">
                      Please fix the errors above before submitting!
                    </p>
                  ) : null
              }
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.jsx